import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { DoctorService } from 'src/app/_service/doctor.service';
import { SharedService } from 'src/app/_service/shared.service';
@Component({
  selector: 'app-doctor-other-info',
  templateUrl: './doctor-other-info.component.html',
  styleUrls: ['./doctor-other-info.component.css']
})
export class DoctorOtherInfoComponent implements OnInit {
  public Editor = ClassicEditor;
  DoctorId: any;
  docOtherInfoForm: FormGroup;
  showdata: any = [];
  loading:boolean=false;
  constructor(private formBuilder: FormBuilder, private doctorapi: DoctorService, private DataSharing: DoctorService,private sharedapi:SharedService) {
    this.DataSharing.SharingData.subscribe((res: any) => {
      this.DoctorId = res;
    })

    this.Editor.defaultConfig = {
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'undo',
          'redo'
        ]
      },
      language: 'en'
    };

    this.docOtherInfoForm = this.formBuilder.group({
      'services': [''],
      'experience': [''],
      'specializations': [''],
      'awards_recognitions': [''],
      'registration': [''],
      'education_details': [''],
      'meta_title': [''],
      'meta_description': [''],
      'og_title': [''],
      'og_description': ['']
    });

  }
  ngOnInit(): void {
    this.DataSharing.SharingData.subscribe((res: any) => {
      this.DoctorId = res;
      this.doctorapi.getDoctorOtherInfo(this.DoctorId).subscribe((DoctorData:any) => {
        this.showdata = DoctorData
        // console.log(this.showdata)
        this.docOtherInfoForm.patchValue({
          services: this.showdata.data.services,
          experience: this.showdata.data.experience,
          specializations: this.showdata.data.specializations,
          awards_recognitions: this.showdata.data.awards_recognitions,
          registration: this.showdata.data.registration,
          education_details: this.showdata.data.education_details,
          meta_title: this.showdata.data.meta_title,
          meta_description: this.showdata.data.meta_description,
          og_title: this.showdata.data.og_title,
          og_description: this.showdata.data.og_description,
        })
      })
    })
  }

  saveDocOtherInfo() {
    this.loading = true;
    this.docOtherInfoForm.value.doc_id = parseInt(this.DoctorId);
    this.doctorapi.DoctorOtherInfo(this.docOtherInfoForm.value).subscribe((result:any) => {
      if(result){
        this.sharedapi.presentToast(result.msg);
        this.loading = false;
      }
    })

  }

}



